import React, { useEffect, useRef } from "react";
import "../styles/MissionVisionValues.css";

const MissionVisionValues = () => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mvv-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    const cards = wrapperRef.current?.querySelectorAll(".mvv-card, .mvv-divider");
    cards?.forEach((el, i) => {
      el.style.setProperty("--mvv-delay", `${i * 0.12}s`);
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="mvv-section">
      <div className="mvv-wrapper" ref={wrapperRef}>

        {/* Mission */}
        <div className="mvv-card">
          <div className="mvv-icon-wrap">
            <i className="fa-solid fa-bullseye"></i>
          </div>
          <div className="mvv-content">
            <h3 className="mvv-title">OUR MISSION</h3>
            <p className="mvv-text">
              To provide accurate, reliable and affordable diagnostic services
              using advanced technology while maintaining the highest standards
              of quality and ethical practices.
            </p>
          </div>
        </div>

        <div className="mvv-divider"></div>

        {/* Vision */}
        <div className="mvv-card">
          <div className="mvv-icon-wrap">
            <i className="fa-regular fa-eye"></i>
          </div>
          <div className="mvv-content">
            <h3 className="mvv-title">OUR VISION</h3>
            <p className="mvv-text">
              To be a leading diagnostic laboratory recognized for excellence,
              innovation and contribution to better healthcare for every
              individual.
            </p>
          </div>
        </div>

        <div className="mvv-divider"></div>

        {/* Values */}
        <div className="mvv-card">
          <div className="mvv-icon-wrap">
            <i className="fa-solid fa-gem"></i>
          </div>
          <div className="mvv-content">
            <h3 className="mvv-title">OUR VALUES</h3>
            <ul className="mvv-values-list">
              <li><i className="fa-solid fa-circle-check"></i> Accuracy &amp; Reliability</li>
              <li><i className="fa-solid fa-circle-check"></i> Compassion &amp; Care</li>
              <li><i className="fa-solid fa-circle-check"></i> Integrity &amp; Transparency</li>
              <li><i className="fa-solid fa-circle-check"></i> Innovation &amp; Excellence</li>
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
};

export default MissionVisionValues;